import TyImg from './TyImg.vue'
export default TyImg



// WEBPACK FOOTER //
// ./src/components/ty-img/index.js